import React, { useState, useEffect, useRef } from 'react';

const PitchListItem = ({
  pitch,
  handleOpenModal,
  isSelected,
  onSelectChange,
  renamePitch
}) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [renameInputVisible, setRenameInputVisible] = useState(false);
  const [renameInput, setRenameInput] = useState('');

  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const renameInputRef = useRef(null);

  const handleDropdownToggle = () => {
    setIsDropdownVisible((prevState) => !prevState);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutsideDropdown = (event) => {
      if (
        isDropdownVisible &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsDropdownVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutsideDropdown);
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideDropdown);
    };
  }, [isDropdownVisible]);

  // Close rename input when clicking outside
  useEffect(() => {
    const handleClickOutsideInput = (event) => {
      if (
        renameInputVisible &&
        renameInputRef.current &&
        !renameInputRef.current.contains(event.target)
      ) {
        setRenameInputVisible(false);
        setRenameInput('');
      }
    };

    document.addEventListener('mousedown', handleClickOutsideInput);
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideInput);
    };
  }, [renameInputVisible]);

  // Focus on rename input when it becomes visible
  useEffect(() => {
    if (renameInputVisible && renameInputRef.current) {
      renameInputRef.current.focus();
    }
  }, [renameInputVisible]);

  // Date formatting
  const dateParts = pitch.post_date.split(' ')[0].split('-');
  const formattedDate = `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
  const fuseNumber = pitch.fuse_list ? pitch.fuse_list.length : 0;

  // Action handlers
  const handleOpenRename = () => {
    setIsDropdownVisible(false);
    setRenameInputVisible(true);
  };

  const handleShare = () => {
    handleOpenModal('share', pitch);
    setIsDropdownVisible(false);
  };

  const handleDelete = () => {
    handleOpenModal('deletePitch', pitch);
    setIsDropdownVisible(false);
  };

  const openPitchLink = () => {
    window.open(pitch.pitch_link, '_blank');
  };

  const handleRenamePitchTitle = () => {
    if (renameInput.trim() === '') {
      // Optionally handle empty input
      return;
    }
    pitch.pitch_title = renameInput;
    setRenameInputVisible(false);
    setRenameInput('');
    renamePitch(pitch.ID, renameInput);
  };

  return (
    <div
      className={`fuselight-dashboard-list-item ${
        pitch.isDeleting ? 'fade-out' : ''
      }`}
    >
      <div className="fuselight-dashboard-item-checkbox">
        <label className="custom-checkbox">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelectChange}
            aria-label={`Select Pitch ${pitch.brand_name}`}
          />
          <span></span>
        </label>
      </div>
      {renameInputVisible && (
        <input
          className="rename-input"
          type="text"
          ref={renameInputRef}
          value={renameInput}
          onChange={(e) => setRenameInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleRenamePitchTitle();
            }
          }}
        />
      )}
      <div className="project-info mobile-buttons-info" onClick={openPitchLink}>
        <p>{pitch.pitch_title}</p>
        <p>
          <span className="fuse-number">{fuseNumber}</span>
        </p>
        <p>{formattedDate}</p>
      </div>
      <div className="dropdown-container">
        <button className="dots" onClick={handleDropdownToggle} ref={buttonRef}>
          <div></div>
          <div></div>
          <div></div>
        </button>
        {isDropdownVisible && (
          <div className="dropdown-menu" ref={dropdownRef}>
            <button className="dropdown-item" onClick={handleOpenRename}>
              Rename
            </button>
            <button className="dropdown-item" onClick={handleShare}>
              Share
            </button>
            <button className="dropdown-item" onClick={handleDelete}>
              Delete
            </button>
          </div>
        )}
      </div>
      <div className="mobile-item-buttons">
        <button className="dropdown-item" onClick={handleShare}>
          Share
        </button>
      </div>
    </div>
  );
};

export default PitchListItem;
